module.exports = __webpack_public_path__ + "single_arrow.jpg?13ea7272fa3fa2c8ccd12b8287427caa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/single_arrow.jpg
// module id = 72
// module chunks = 0